import { createSelector } from "reselect"
import { capitalize, find } from "lodash"
import { getForecastId } from "./items"
import { getFactorCategoryName } from "."
import { getForecastData } from "./forecast"

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate
const getPositionSetName = (_, props) => props.positionSetName
const getViewType = (_, props) => props.viewType

export const getScreenName = createSelector(
  [getForecastData, getForecastId],
  (forecasts, forecastId) => {
    if (forecastId) {
      const forecast = find(forecasts, ({ id }) => id === forecastId)
      if (forecast) {
        return `${forecast.name} % Expected Return`
      }
    }
    return "Forecast"
  },
)

export const getFileName = createSelector(
  [getPositionSetName, getFactorCategoryName, getViewType, getScreenName, getStartDate, getEndDate],
  (positionSetName, factorCategoryName, viewType, screenName, startDate, endDate) => `${positionSetName} ${factorCategoryName} ${capitalize(viewType)} ${screenName} ${startDate} - ${endDate}`,
)
